import { useEffect, useState } from "react";
import useTailwind, { TailwindTheme } from "hooks/useTailwind";
import { useWindowSize } from "hooks/useWindowSize";

type breakpoints = keyof TailwindTheme["screens"];
/**
 * Check if the screen is above a certain breakpoint (xl: 1320, lg: 1024px, md: 768px, sm: 576, xs: 375)
 * @param breakpoint - The breakpoint to check against
 * @returns A boolean indicating if the screen is above the breakpoint
 * */
export function useScreenIsAboveBreakpoint(breakpoint: breakpoints) {
  const { width } = useWindowSize();
  const [isAbove, setIsAbove] = useState<boolean | null>(null);
  const tailwind = useTailwind();

  const breakpointWidth = parseInt(tailwind.theme.screens[breakpoint].replace("px", ""), 10);

  useEffect(() => {
    if (width && breakpointWidth) {
      setIsAbove(width >= breakpointWidth);
    } else {
      setIsAbove(null);
    }
  }, [width, breakpoint, breakpointWidth]);

  return isAbove;
}
